var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6669 18C10.3683 18 10.0696 17.8824 9.84212 17.6484C9.38596 17.1791 9.38596 16.4207 9.84212 15.9515L13.6978 11.9852L9.98795 8.03327C9.54112 7.55564 9.55396 6.79598 10.0171 6.33635C10.4814 5.87672 11.2199 5.88992 11.6667 6.36515L16.1723 11.1655C16.6144 11.6371 16.6086 12.3848 16.1583 12.848L11.4917 17.6484C11.2642 17.8824 10.9656 18 10.6669 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.5e69cc81320db94f5f926ab6caf74440.svg";
export { ForwardRef as ReactComponent };